import _ from 'lodash';
import mixin from "../mixin";
import {
    MAIN_CONTRACT
} from '../utils/constants';

const INIT_PRICE = '0.1000 EOS';

export default {
    name: "edit",
    mixins: [mixin],
    created() {
        this.account = this.$route.params.account;
        this.waitingForLogin();
        this.getBaseInfo();


        this.infoTimer = setInterval(() => {
            this.getPrice();
        }, 5000);;

        const query = location.search.substr(1);
        const queryObj = {};

        if (query) {
            _.forEach(query.split('&'), item => {
                const tempArr = item.split('=');
                queryObj[tempArr[0]] = tempArr[1];
            });
        }

        if (queryObj['refer']) {
            this.refer = _.trim(queryObj['refer']);
        }
    },
    beforeDestroy() {
        clearInterval(this.infoTimer);
    },
    data() {
        return {
            account: '',
            title: '',
            avatar: '',
            desc: '',
            website: '',
            telegram: '',
            twitter: '',
            facebook: '',
            wechat: '',
            cost: '',
            modifier: '',
            hasInfo: false,
            status: '',
            refer: '',
            infoTimer: null
        }
    },
    computed: {
        uploadData: vm => {
            return {
                path: 'avatar/',
                filename: vm.account
            }
        }
    },
    methods: {
        waitingForLogin() {
            if (this.currentAccount) {
                this.getBaseInfo();
            } else {
                setTimeout(this.waitingForLogin, 1000);
            }
        },
        getPrice() {
            this.readonlyEos.getTableRows(true,
                MAIN_CONTRACT,
                MAIN_CONTRACT,
                "accounts",
                "",
                this.account,
                this.account,
                1).then(res => {
                if (!!res.rows.length) {
                    let info = res.rows[0];
                    this.hasInfo = true;

                    this.status = info.status;
                    this.modifier = info.modifier;

                    let basePrice = parseFloat(info.price);

                    if (this.account === this.currentAccount) {
                        this.cost = parseFloat(basePrice / 2).toFixed(4) + ' EOS';
                    } else {
                        this.cost = parseFloat(basePrice * 1.5).toFixed(4) + ' EOS';
                    }

                } else {
                    this.cost = INIT_PRICE;
                }
            })
        },
        getBaseInfo() {
            this.readonlyEos.getTableRows(true,
                MAIN_CONTRACT,
                MAIN_CONTRACT,
                "accounts",
                "",
                this.account,
                this.account,
                1).then(res => {
                if (!!res.rows.length) {
                    let info = res.rows[0];
                    this.hasInfo = true;
                    this.title = info.title;
                    this.avatar = info.avatar;
                    this.desc = info.desc;
                    this.modifier = info.modifier;
                    this.status = info.status;
                    this.modifier = info.modifier;

                    let basePrice = parseFloat(info.price);

                    if (this.account === this.currentAccount) {
                        this.cost = parseFloat(basePrice / 2).toFixed(4) + ' EOS';
                    } else {
                        this.cost = parseFloat(basePrice * 1.5).toFixed(4) + ' EOS';
                    }

                    // this.cost = parseFloat(parseFloat(info.price) * 1.5).toFixed(4) + ' EOS';
                    if (info.url) {
                        try {
                            let url = JSON.parse(info.url);
                            this.website = url.website;
                            this.telegram = url.telegram;
                            this.twitter = url.twitter;
                            this.wechat = url.wechat;

                        } catch (err) {
                            console.log(err);
                        }
                    }
                } else {
                    this.cost = INIT_PRICE;
                }
            })
        },
        beforeAvatarUpload() {},
        handleAvatarSuccess(res, file) {
            if (res.result) {
                this.avatar = res.data.url;
            }
        },
        onSave() {
            let url = {
                website: this.website,
                telegram: this.telegram,
                twitter: this.twitter,
                wechat: this.wechat
            }

            let memo = this.account;
            if (this.refer) {
                memo += '-' + this.refer;
            }

            var actions = [{
                "account": "eosio.token",
                "name": "transfer",
                "authorization": [{
                    "actor": this.currentAccount,
                    "permission": this.currentPermission
                }],
                "data": {
                    "from": this.currentAccount,
                    "memo": memo,
                    "quantity": this.cost,
                    "to": MAIN_CONTRACT
                }
            }, {
                "account": MAIN_CONTRACT,
                "name": "update",
                "authorization": [{
                    "actor": this.currentAccount,
                    "permission": this.currentPermission
                }],
                "data": {
                    "account_name": this.account,
                    "avatar": this.avatar,
                    "desc": this.desc,
                    "modifier": this.currentAccount,
                    "title": this.title,
                    "url": JSON.stringify(url)
                },

            }]

            if (this.status === 3) {
                actions = [actions.pop()];
            }


            this.scatter.eosClient.transaction({
                actions
            }).then(res => {
                this.msg = this.$t('i18nView.success');
                this.$modal.show("message");
                setTimeout(() => {
                    this.$router.push('/' + this.account);
                }, 2000);

            }).catch(err => {
                this.handleError(err);
            })
        }
    }
};